// LIBRERIE/IMPORTS
import React from "react";

interface SubHeaderProps {
  title: string;
  isSeo: boolean;
}

const SubHeaderDefault: React.FC<SubHeaderProps> = ({ title, isSeo }) => {
  return (
    <div id="subHeader_default" className="bg-overlay-black-10">
      <div className="container">
        <div className="row flex-column align-items-center text-center">
          {isSeo ? (
            <h1 className="text-primary">{title}</h1>
          ) : (
            <h2 className="text-white asH1Title">{title}</h2>
          )}
          <p className="subTitle-reverse">{title}</p>
        </div>
      </div>
    </div>
  );
};

export default SubHeaderDefault;